import siteConfig from "site-config";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { COLLECTIONS, MUTATE_OPERATIONS_SENT } from "constants/action-types";
import { mapToOperation } from "./helpers/mapToOperation";
import { getAndIncrementRequestId } from "./helpers/getAndIncrementRequestId";
import { fromJS, List } from "immutable";
import { mapSetOperation } from "actions/mutate";

export const mutateValidationLog = (action$, state) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.VALIDATION_LOG.MUTATE)
        .map(({ payload }: { payload: { key: string; newLog: nuorder.collection.validation_log.ValidationLog } }) => {
            const { key, newLog } = payload;
            return mapSetOperation("export_validation_status", key, fromJS({ struct_value: newLog }));
        });

export const validationLogSync = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.VALIDATION_LOG.SYNC.START)
        .filter(({ payload: { objectId } }) => {
            const { mutate } = store.getState();
            const { sentMutations, uncommittedMutations } = mutate;
            const sentMutation = sentMutations.get(objectId);
            const uncommittedMutation = uncommittedMutations.get(objectId) || List();

            return !sentMutation && !!uncommittedMutation.size;
        })
        .map(({ payload }) => {
            const { collection, mutate } = store.getState();
            const { committedHEADs, uncommittedMutations } = mutate;
            const { sessionId, merchantId } = collection;
            const { objectId } = payload;

            const committedHEAD = committedHEADs.get(objectId);

            const operations = [];

            uncommittedMutations.getIn([objectId, 0]).operations.forEach((operation) => {
                const { set } = mapToOperation(operation);
                if (set) {
                    operations.push({ set: { ...set, key: operation.key, value: set.value.struct_value } });
                }
            });

            const requestId = getAndIncrementRequestId(objectId);
            const revision = parseInt(committedHEAD.revision, 10) + 1;
            const command = {
                operations,
                merchant_id: merchantId,
                req_id: requestId,
                revision,
            };

            store.dispatch({
                type: MUTATE_OPERATIONS_SENT,
                payload: {
                    requestId,
                    objectId,
                    revision,
                    objectType: committedHEAD.object_type,
                    sentMutationsIndex: 0,
                },
            });
            return { command, sessionId, requestId, collectionId: committedHEAD.document_id, merchantId };
        })
        .concatMap(({ collectionId, requestId, sessionId, merchantId, command }) => {
            const url = `/v1/collections/${collectionId}/export_validation_status/mutate?sid=${sessionId}&req_id=${requestId}`;
            return ajax({
                body: { ...command, merchant_id: merchantId },
                method: "POST",
                url: siteConfig.goAPI + url,
            }).map(() => ({ type: COLLECTIONS.COLLECTION.VALIDATION_LOG.SYNC.COMPLETE }));
        });
};
